// libs
import styled, { css } from 'styled-components'
// views
import { darkCellCSS, darkTextAreaCSS, Row } from '../../views'
// theme
import { colors } from 'themes/index'

const RightRowsContainer = styled.div`
  padding: 4px;
  display: flex;
  gap: 4px;
`

const RightRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 200px;

  > div:first-child {
    height: 70px;

    ${darkCellCSS};
    ${darkTextAreaCSS};

    textarea {
      height: 70px;

      ::placeholder {
        line-height: 40px;
      }
    }
  }
`

const RightRowsWrapper = styled.div<{ appetiteEnabled: boolean; activeColumn: number }>`
  display: flex;
  gap: 4px;

  ${({ activeColumn, appetiteEnabled }) =>
    appetiteEnabled &&
    (activeColumn >= 0
      ? css`
          > div:nth-child(${activeColumn}) {
            > div:first-child {
              border: 3px solid ${colors.green600};
            }
          }

          > div:not(:nth-child(${activeColumn})) {
            pointer-events: none;

            > div:not(:first-child) {
              ${Row} {
                background-color: ${colors.gray230};
              }
            }
          }
        `
      : css`
          > div {
            pointer-events: none;

            > div:not(:first-child) {
              ${Row} {
                background-color: ${colors.gray230};
              }
            }
          }
        `)};
`

export { RightRowsContainer, RightRowsWrapper, RightRow }
